const widgetId = 'FdqUYL';
let supportLoad = null;

function hideMobileWidgetIcon() {
    if (window.innerWidth >= 768) return;
    window.Goftino?.setWidget?.({
        hasIcon: false,
        marginBottom: document.querySelector('.single-product__mobile-buy-bar') ? 128 : 72,
    });
}

function loadSupport() {
    if (window.Goftino?.open) return Promise.resolve(window.Goftino);
    if (supportLoad) return supportLoad;

    supportLoad = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        let timer;
        const cleanup = () => {
            clearTimeout(timer);
            window.removeEventListener('goftino_ready', ready);
        };
        const ready = () => {
            if (!window.Goftino?.open) return;
            cleanup();
            hideMobileWidgetIcon();
            resolve(window.Goftino);
        };
        const fail = () => {
            cleanup();
            script.remove();
            supportLoad = null;
            reject(new Error('Support widget could not load'));
        };
        window.addEventListener('goftino_ready', ready);
        script.async = true;
        script.src = 'https://www.goftino.com/widget/' + widgetId;
        try {
            const session = localStorage.getItem('goftino_' + widgetId);
            if (session) script.src += '?o=' + encodeURIComponent(session);
        } catch (error) {
            // Chat also works when browser storage is unavailable.
        }
        script.onerror = fail;
        timer = setTimeout(fail, 20000);
        document.head.appendChild(script);
    });
    return supportLoad;
}

window.openPediniSupport = () => loadSupport().then(widget => {
    hideMobileWidgetIcon();
    widget.open();
});

// Mobile already has a support button: load the SDK on its first click.
// Desktop keeps the vendor's original floating button and automatic loading.
function loadDesktopSupport() {
    if (window.innerWidth >= 768) loadSupport().catch(() => {});
    hideMobileWidgetIcon();
}
if (document.readyState === 'complete') loadDesktopSupport();
else window.addEventListener('load', loadDesktopSupport, {once: true});
window.addEventListener('resize', loadDesktopSupport);
document.addEventListener('page:load', hideMobileWidgetIcon);
